module.exports = __webpack_public_path__ + "img/valve_close.b10245a1.svg";